export const copilotDotCom = {
  prod: 'copilot.com',
  staging: 'copilot-staging.com',
};

export const copilotApp = {
  prod: 'copilot.app',
  staging: 'copilot-staging.app',
};
